import React from 'react'

import RitForm from '../form/RitForm'
import RitInfoToggle from '../info/RitInfoToggle'
import StepProgressBar from '../step-progress-bar/StepProgressBar'
import SubmitRitForm from '../form/SubmitRitForm'
import RitQuestion from './RitQuestion'
import JurisdictionSelector from '../rate-implicit-tool/JurisdictionSelector'

export default function RitTemplate({ formData, submitAnswer, submitForm }) {
	const {
		progress,
		navigation,
		definition,
		info,
		answer,
		subAnswer,
		content,
	} = formData

	const stepsArray = [
		'Jurisdiction',
		'Dates',
		'Fair Value',
		'Payments',
		'Residual Value',
		'Results',
	]

	return (
		<>
			<div className='step-Container'>
				<StepProgressBar steps={stepsArray} currentStepNumber={progress} />
			</div>
			<div className='page-Container'>
				<div className={progress === 4 ? 'no-Column' : 'column-Left'}>
					{progress === 4 ? '' : <RitQuestion definition={definition} />}
					{navigation ? (
						<RitForm
							progress={progress}
							content={content}
							definition={definition}
							value={answer ? answer : ''}
							subValue={subAnswer ? subAnswer : ''}
							submitAnswer={submitAnswer}
							navigation={navigation}
						/>
					) : (
						<SubmitRitForm submitForm={submitForm} />
					)}
				</div>

				{info && progress !== 1 ? (
					<div className='column-Right'>
						<RitInfoToggle info={info} progress={progress} />{' '}
					</div>
				) : null}
				{progress === 1 && !info ? (
					<div className='column-Right' style={{ marginTop: '-50px' }}>
						<JurisdictionSelector />
					</div>
				) : null}
			</div>
		</>
	)
}
